import React from 'react';

export default function CurriculumPreview({ templates = [], completedTaskIds = [], showDayOffset = true, compact = false, className = '' }) {
  const sorted = [...templates].sort((a, b) => (a.day_offset || 0) - (b.day_offset || 0));
  if (compact) {
    return (
      <div className={`space-y-2 ${className}`}>
        {sorted.map((t, idx) => {
          const done = completedTaskIds.includes(t.id);
          return (
            <div key={t.id || idx} className={`flex items-center gap-3 p-3 rounded-lg border border-succession-border bg-succession-bg-secondary ${done ? 'opacity-60' : ''}`}>
              <div 
                className="w-6 h-6 rounded-full text-white flex items-center justify-center text-xs font-medium"
                style={{ backgroundColor: 'var(--succession-text-primary, #1f2937)' }}
              >
                {idx + 1}
              </div>
              <div className="min-w-0 flex-1">
                <p className={`text-sm font-medium truncate text-succession-text-primary ${done ? 'line-through text-succession-text-muted' : ''}`}>{t.title}</p>
              </div>
              {showDayOffset && <span className="text-xs rounded px-2 py-1 bg-succession-bg-secondary text-succession-text-secondary">Day {t.day_offset || idx}</span>}
            </div>
          );
        })}
        {sorted.length === 0 && (
          <div className="p-8 text-center border border-succession-border rounded-lg border-dashed text-succession-text-secondary">No tasks in this program yet.</div>
        )}
      </div>
    );
  }
  return (
    <div className={`space-y-2 ${className}`}>
      {sorted.map((t, idx) => {
        const done = completedTaskIds.includes(t.id);
        return (
          <div key={t.id || idx} className={`p-3 rounded-lg border border-succession-border bg-succession-bg-secondary ${done ? 'opacity-60' : ''}`}>
            <div className="flex items-center gap-3">
              <div 
                className="w-8 h-8 rounded-full text-white flex items-center justify-center text-sm font-semibold flex-shrink-0"
                style={{ backgroundColor: 'var(--succession-text-primary, #1f2937)' }}
              >
                {idx + 1}
              </div>
              <div className="min-w-0 flex-1">
                <h4 className={`text-sm font-medium text-succession-text-primary ${done ? 'line-through text-succession-text-muted' : ''}`}>Task {idx + 1}</h4>
                <p className="text-xs text-succession-text-secondary mt-0.5">
                  {t.description_md ? t.description_md : 'Details revealed after enrollment'}
                </p>
              </div>
              {showDayOffset && (
                <span className="text-xs text-succession-text-secondary flex-shrink-0">Day {t.day_offset || idx}</span>
              )}
            </div>
          </div>
        );
      })}
      {sorted.length === 0 && (
        <div className="p-8 text-center border border-succession-border rounded-lg border-dashed text-succession-text-secondary">No tasks in this program yet.</div>
      )}
    </div>
  );
}


